class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    if (window.matchMedia('(max-width: 768px)').matches) {
      //クリックで動く
      $('.nav-open').click(function(){
        $(this).toggleClass('is-active');
        $(this).next('div').slideToggle();
      });

    }

    const aboutAcc = document.querySelector(".js-about-acc")

    if(aboutAcc){
      //クリックで動く
      $('.js-about-trigger').click(function(){
        $(this).toggleClass('is-active');
        $(this).next().slideToggle(300);
      });
    }

    const careerAcc = document.querySelector(".js-career-acc")

    if(careerAcc){

      if (window.matchMedia('(max-width: 768px)').matches) {
        //クリックで動く
        $('.js-box-02-acc').click(function(){
          $(this).toggleClass('is-active');
          $(this).find('.item-txt').slideToggle();
        });

      }

    }

  }
}
